import { TrackingHandler } from '../tracking/TrackingHandler';
import { getCss, getScript } from './get-resource';
import { getUrlParameter } from './browser';
const EXPERIMENT_NAME = 'aida_chat';
const EXPERIMENT_VARIATIONS = ['active', 'inactive'];
const CHAT_WIDGET_TIMEOUT = 10000;
const loadChat = async () => {
    const trackingHandler = TrackingHandler.getInstance();
    await trackingHandler.consentGranted('essential');
    window.webChatWidgetTitle = 'Chat';
    window.webChatWidgetSubtitle = '';
    window.webChatWidgetChannelId = window.siteSettings.aidaChannelId;
    window.webChatWidgetPopBehavior = 'silent';
    window.webChatWidgetTheme = 'default';
    window.webChatWidgetLanguageId = '1';
    window.webChatWidgetToken = window.siteSettings.aidaToken ?? 'default';
    window.webChatWidgetCloseButton = false;
    if (typeof window.siteStyles === 'object' && typeof window.siteStyles['color-primary'] === 'string') {
        window.webChatWidgetTheme = window.siteStyles['color-primary'];
    }
    await Promise.all([
        getCss(window.endpoints.webChatDomain + '/static/css/web-chat-widget.css'),
        getScript(window.endpoints.webChatDomain + '/static/js/web-chat-widget.js'),
    ]);
    if (typeof window.startWebChatWidget === 'undefined') {
        return;
    }
    if (window.isWebChatWidgetActive) {
        window.startWebChatWidget(trackingHandler.getAllTrackingData());
        return;
    }
    window.setTimeout(() => {
        window.startWebChatWidget(trackingHandler.getAllTrackingData());
    }, CHAT_WIDGET_TIMEOUT);
};
export const initChat = async () => {
    if (typeof window.siteSettings !== 'object' || typeof window.siteSettings.aidaChannelId !== 'string') {
        return;
    }
    const container = document.createElement('div');
    container.id = 'web-chat-widget';
    document.body.appendChild(container);
    if (window.siteSettings.enableAIDA || getUrlParameter('enableAIDA')) {
        loadChat();
        return;
    }
    if (!window.siteSettings.enableAIDATest) {
        return;
    }
    const variation = await TrackingHandler.getInstance().getExperimentVariation(EXPERIMENT_NAME, EXPERIMENT_VARIATIONS);
    if (variation === 'active') {
        loadChat();
    }
};
